module.exports = __webpack_public_path__ + "static/img/promotion1.77c0fd6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/image/promotion1.jpg
// module id = 6q2L
// module chunks = 1